export default "__VITE_ASSET__DaA5Yx_T__"